module.exports = __webpack_public_path__ + "media/images/logos/Tatler-logo-a7a9a677cfbd51c9215cdf5a53cf0b16.svg";